export default __webpack_public_path__ + "static/media/right-arrow.efcdea8c.svg";